export enum UploadImageEnum {
  CHOOSE_PROFILE_PICTURE = 1,
  DROPZONE,
  CROP,
  CHOSE_SECONDARY_AVATAR,
}
